<mat-toolbar class="header">
    <mat-toolbar-row>
        <!-- <img class="logo-img" src="../../assets/img/synapsis_logo.png"> -->
        <img class="logo-img" src="../../assets/img/epago.svg">
    </mat-toolbar-row>
</mat-toolbar>